// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3745":"d666f47a","8629":"875c1911"}[chunkId] + ".chunk.css";
};